<template>
  <encryption-field
    v-if="encrypted" :field-name="fieldName" :encrypted-value="value"
    :label="fieldName"
  />
  <el-input
    v-else :value="value" v-bind="$attrs"
    v-on="$listeners"
  />
</template>
<script>
import EncryptionField from '@/components/EncryptionField/index.vue';
export default {
  name: 'SensitiveInput',
  components: { EncryptionField },
  inheritAttrs: false,
  props: { value: { type: [String, Number], default: '' }, fieldName: { type: String, required: true }},
  computed: { encrypted() { return typeof this.value === 'string' && this.value.trim().startsWith('{$'); } }
};
</script>
